'use client';

import { Language } from '@/types/language';
import { formatRelativeTime } from '@/utils/timeUtils';
import { useEffect, useMemo, useState } from 'react';

interface TimeAgoProps {
  dateTime: string;
  language: Language;
}

const TimeAgo = ({ dateTime, language }: TimeAgoProps) => {
  const date = useMemo(() => new Date(dateTime), [dateTime]);
  const [timeAgo, setTimeAgo] = useState<string>(() => formatRelativeTime(date, language));

  const updateTimeAgo = () => {
    setTimeAgo(formatRelativeTime(date, language));
  };

  useEffect(() => {
    updateTimeAgo();
    const interval = setInterval(() => updateTimeAgo(), 2000);
    return () => clearInterval(interval);
  }, []);

  return <time dateTime={date.toISOString()}>{timeAgo}</time>;
}

export default TimeAgo;